import { defineStore } from 'pinia'
import { ref } from 'vue'

interface TempLineData {
  display_name: string
  avatar: string
  lineid: string
  token: string
  channelid?: string
  orgid?: number
}

export const useAuthStore = defineStore('auth', () => {
  // 暫存的 LINE 登入資料 (用於註冊流程)
  const tempLineData = ref<TempLineData | null>(null)

  // 設定暫存 LINE 資料
  const setTempLineData = (data: TempLineData) => {
    tempLineData.value = data
  }

  // 清除暫存 LINE 資料
  const clearTempLineData = () => {
    tempLineData.value = null
  }

  // 檢查是否有暫存的 LINE 資料
  const hasTempLineData = () => {
    return tempLineData.value !== null
  }

  return {
    tempLineData,
    setTempLineData,
    clearTempLineData,
    hasTempLineData
  }
})